import React, {Component, Fragment} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle,
} from 'reactstrap';
import {Field, Form as FinalForm} from 'react-final-form';
import {withTranslation} from 'react-i18next';
import TextField from '../../../../components/TextField';
import {Colxx, Separator} from '../../../../components/common/CustomBootstrap';
import {NotificationManager} from '../../../../components/common/react-notifications';
import LoaderButton from '../../../../components/LoaderButton';
import Breadcrumb from '../../../../containers/navs/Breadcrumb';
import {required} from '../../../../helpers/Validators';
import FieldError from '../../../../components/FieldError';
import permissions from "../../../../constants/permissions";
import Skeleton from 'react-loading-skeleton';
import {includes, map, reduce} from 'lodash';
import Api from '../../../../services/Api';
import Select from 'react-select';

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rbac: null,
      loading: true,
    };
    const username = localStorage.getItem('username');
    this.permissionOptions = reduce(permissions, (result, item) => {
      if (username !== "superadmin" && item.onlyForSuperAdmin) {
        return result;
      }
      return [...result, item];
    }, []);
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    try {
      const {data} = await Api.invoke('GET', '/admin-ui/rbac');
      this.setState({
        rbac: data,
        loading: false,
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  createRole = async values => {
    const {t} = this.props;
    const {rbac} = this.state;
    const newRbac = {
      ...rbac,
      roles: rbac.roles ? [...rbac.roles, values.title] : [values.title],
      grants: rbac.grants ? {...rbac.grants, [values.title]: map(values.permissions, 'value')} :
        {[values.title]: map(values.permissions, 'value')},
    };
    try {
      await Api.invoke('PUT', '/admin-ui/rbac', {
        rbac: JSON.stringify(newRbac),
      });
      this.setState({rbac: newRbac});
      NotificationManager.success(t('Role created successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  validate = values => {
    const error = {};
    const {title} = values;
    const {rbac} = this.state;
    if (title) {
      if (rbac && rbac.roles && includes(rbac.roles, title)) {
        error.title = this.props.t('This role has already been created');
      }
    }
    return error;
  };

  ReactSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      isMulti
      placeholder={this.props.t('Select')}
    />
  );

  render() {
    const {t, match} = this.props;
    const {loading, rbac} = this.state;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {t('Create Role')}
                </CardTitle>
                <FinalForm
                  onSubmit={this.createRole}
                  validate={this.validate}
                  render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
                   return (
                     <Form onSubmit={handleSubmit}>
                       <Row>
                         <Col className='col-lg-6 col-md-12'>
                           {!loading ?
                             <TextField
                               item={{
                                 name: 'title',
                                 i18n: t('Role Title'),
                                 type: 'text',
                                 required: true,
                               }}
                             />
                             :
                             <Skeleton height={40}/>
                           }
                         </Col>
                       </Row>
                       <Row>
                         <Col className='col-lg-6 col-md-12'>
                           <span>
                             {t('Permissions')}
                             <span className="required">*</span>
                           </span>
                           <Field
                             name="permissions"
                             component={this.ReactSelectAdapter}
                             isLoading={loading}
                             options={rbac && rbac.roles ?
                               [...rbac.roles.map(role => ({label: role, value: role})), ...this.permissionOptions] :
                               this.permissionOptions
                             }
                             validate={required}
                             closeMenuOnSelect={false}
                           />
                           <FieldError name='permissions' />
                         </Col>
                       </Row>
                       <LoaderButton
                         loading={submitting}
                         onClick={handleSubmit}
                         disabled={pristine || hasValidationErrors || submitting}
                         className="mt-4 text-center"
                         style={{minWidth: '100px'}}>
                         {t('Save')}
                       </LoaderButton>
                     </Form>
                   );
                 }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(Create);
